;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import BlockStaticAlertBar from './BlockStaticAlertBar';

const query = /* GraphQL */ `
    query getBlock($id: String!, $preview: Boolean!) {
        blockStaticAlertBar(preview: $preview, id: $id) {
            __typename
            sys {
                id
            }
            message {
                json
            }
            backgroundColor
            textColor
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockStaticAlertBar },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockStaticAlertBar;
}

const BlockStaticAlertBarServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockStaticAlertBar {...block} />;
};

export default BlockStaticAlertBarServer;
